import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import store from './redux/store';
import MainApp from './container/MainApp';
import { NotificationContainer } from 'react-notifications';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import './assets/css/custom.css';
//import 'react-notifications/lib/notifications.css';
//import "react-big-calendar/lib/css/react-big-calendar.css";
// locale
import moment from 'moment';
// without this line it didn't work
// import vi_VN from 'antd/lib/locale-provider/vi_VN';
import Wrapper from './lang';
import en_US from './lang/locales/en_US';
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from '@tanstack/react-query';
import 'moment-timezone';
import {
  persistQueryClient,
  PersistQueryClientProvider,
} from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import locale from 'antd/locale/fr_FR';
// moment.locale('vi');
moment.locale('fr');
// dayjs.locale('en')
moment.tz.setDefault('Africa/Dakar');
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: 1000 * 60 * 60 * 12, // 12 hours
      cacheTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
});

const persister = createSyncStoragePersister({
  storage: window.localStorage,
});

persistQueryClient({
  queryClient,
  persister,
  maxAge: 1000 * 60 * 60 * 24, // 24 hours
  buster: '',
  hydrateOptions: undefined,
  dehydrateOptions: undefined,
});

export default class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <ConfigProvider
          locale={locale}
          theme={{
            token: {
              colorPrimary: '#15bc8c',
              borderRadiusBase: '2px',
            },
            components: {
              Switch: {
                colorPrimary: '#00b96b',
              },
            },
          }}>
          <BrowserRouter>
            <Wrapper>
              <PersistQueryClientProvider
                client={queryClient}
                persistOptions={{ persister }}>
                <ReactQueryDevtools initialIsOpen={false} />

                <MainApp />
              </PersistQueryClientProvider>
            </Wrapper>
            <NotificationContainer />
          </BrowserRouter>
        </ConfigProvider>
      </Provider>
    );
  }
}
